import mobileMenu from "./mobileMenu";

mobileMenu({
    selector: {
        header: ".header",
        navigation: ".nav",
        openOnTap: false
    }
});

/*

If you want the react on the menu open or menu close event you can 
register event listener on mobileMenu.open and mobileMenu.close.
Example

document.addEventListener("mobileMenu.open", () => {
    // Do something on open
});


options for the function:
mobileMenu({
    selector: {
        header: "The selector for the page-header",
        navigation: "The selector for the navigation inside the header",
        hamburger: "The selector for the hamburger inside the header",
        openOnTap: "Elements who should open on the first tap, on the second go to the href",
        focusable: "All focusable elments inside the header"
    }
    menuOpen: "This CSS class will add the the body and the html element if the menu is open",
    focusWithin: "In this element the focus within fallback will be added",
    isTouch: "boolean to check if we are on a mobile device",
    setTop: "calculate style='top:' on the body elment.
});


// Function with all default values:
mobileMenu({
    selector: {
        header: ".page-header",
        navigation: ".mainnav",
        hamburger: ".hamburger-icon",
        openOnTap: ".mainnav__element--hassub > a.mainnav__link--level1",
        focusable: [
            "a[href]",
            "area[href]",
            "input:not([disabled])",
            "select:not([disabled])",
            "textarea:not([disabled])",
            "button:not([disabled])",
            "iframe",
            "object",
            "embed",
            "[contenteditable]",
            "[tabindex]:not([tabindex^='-'])"
        ].join(",")
    },
    menuOpen: "-menuopen",
    focusWithin: document,
    isTouch: "ontouchstart" in document.documentElement,
    setTop: false
});
*/
